import { InfinityIcon } from "@images/svgIcons/infinityIcon"
import { OnOffIcon } from "@images/svgIcons/onOffIcon"
import { word } from "@modules/core/utils/i18n"
import { InputContainer } from "@modules/formik/components/inputContainer"
import { ProgramBundleType } from "@modules/programBundle/api/programBundleDto"
import { HUText } from "@modules/ui/components/huText"
import { FieldValueChange } from "@src/typings/formik"
import { FieldInputProps } from "formik"
import { useTheme } from "styled-components"

type ProgramBundleTypeInputProps<T, K> = {
  label: string
  name: string
  isInvalid: boolean
  isRequiredInput: boolean
  setFieldValue: FieldValueChange<K>
  getFieldProps: (nameOrOptions: T) => FieldInputProps<any>
  error?: React.JSX.Element
  defaultType?: ProgramBundleType
  isSwitchEnabled?: boolean
} & React.HTMLAttributes<HTMLDivElement>

export function ProgramBundleTypeInput<T, K>({
  label,
  name,
  isRequiredInput,
  isInvalid,
  setFieldValue,
  getFieldProps,
  error,
  isSwitchEnabled = true,
  ...props
}: ProgramBundleTypeInputProps<T, K>): React.JSX.Element {
  const theme = useTheme()
  const programType = getFieldProps(name as string as T).value as ProgramBundleType
  const isVirtual = programType === ProgramBundleType.VIRTUAL
  const isOnOff = programType === ProgramBundleType.ON_OFF

  const handleTypeChange = (type: ProgramBundleType) => {
    if (isSwitchEnabled) setFieldValue(name, type)
  }

  return (
    <>
      <InputContainer
        isRequiredInput={isRequiredInput}
        label={label}
        name={name}
        isInvalid={isInvalid}
        error={error}
        {...props}
      >
        <div className="flex gap-2 align-items-center">
          <div
            className={`flex flex-grow-1 rounded-big-radius
              px-4 py-3 gap-2
              align-items-center justify-content-center ${isSwitchEnabled ? "cursor-pointer" : ""}
              ${isVirtual ? "bg-primary-500" : "bg-neutralColor-200"}`}
            onClick={() => handleTypeChange(ProgramBundleType.VIRTUAL)}
          >
            <InfinityIcon color={isVirtual ? theme.secondaryColor : theme.neutralColor} width={24} height={24} />
            <HUText fontStyle="LM" color={isVirtual ? theme.secondaryColor : theme.neutralColor}>
              {word("programBundle.typeOfPrograms.infitePrograms")}
            </HUText>
          </div>
          <HUText className="flex capitalize" fontStyle="LM" color={theme.mainBlack}>
            {word("global.or")}
          </HUText>
          <div
            className={`flex flex-grow-1 rounded-big-radius
            px-4 py-3 gap-2
            align-items-center justify-content-center ${isSwitchEnabled ? "cursor-pointer" : ""}
            ${isOnOff ? "bg-primary-500" : "bg-neutralColor-200"}`}
            onClick={() => handleTypeChange(ProgramBundleType.ON_OFF)}
          >
            <OnOffIcon color={isOnOff ? theme.secondaryColor : theme.neutralColor} width={24} height={24} />
            <HUText fontStyle="LM" color={isOnOff ? theme.secondaryColor : theme.neutralColor}>
              {word("programBundle.typeOfPrograms.onOffPrograms")}
            </HUText>
          </div>
        </div>
      </InputContainer>
    </>
  )
}
